











































































































import Vue from 'vue';
import Validation from '../../mixins/validation';
import IconCarat from '@/components/dumb/IconCarat.vue';
import FieldNativeSelect from '@/components/dumb/FieldNativeSelect.vue';
export default Vue.extend({
	name: 'OldBirthdayField', 
	components: {
		IconCarat, 
		FieldNativeSelect
	},
	props: {
		value: String
	},
	data(){
		return {
			isTouchEnabled: false,
			days: [],
			years: [],
			months: [],
			form: {
				birthday: {
					value: '', 
					isValid: false, 
					day: {
						value: '', 
						isDirty: false, 
						isFocussed: false
					},
					month: {
						value: '',
						isDirty: false, 
						isFocussed: false
					},
					year: {
						value: '',
						isDirty: false,
						isFocussed: false
					}
				}
			}
		};
	}, 
	computed: { 
		birthdayErrorMessages(): string {
			const m1 = Validation.isDate(this.dateString);
			const m2 = m1 === true ? Validation.isOver18(this.dateString) : '';
			let m = '';
			if (m1 !== true){
				m = m1
			}
			else if (m2 !== true){
				m = m2;
			}
			const isError = 
				m && 
				this.isDirty;
			return isError ? m : '';
		}, 
		monthNumber(): number {
			return (this.months as any).indexOf(this.form.birthday.month.value) + 1;
		},
		dateString(): any {
			let m = this.monthNumber.toString();
			m = !!this.monthNumber && this.monthNumber < 10 ? "0" + m : m;
			let d = this.form.birthday.day.value.toString();
			d = !!this.form.birthday.day.value && this.form.birthday.day.value.length < 2 ? "0" + d : d;
			return `${this.form.birthday.year.value}-${m}-${d}`;
		}, 
		isDirty(): boolean {
			return this.form.birthday.day.isDirty &&
				this.form.birthday.month.isDirty && 
				this.form.birthday.year.isDirty;
		}
	},
	methods: {
		getDays(): any {
			const d: Array<string> = [];
			for (let i = 0; i != 31; ++i){
				let day = (i+1).toString();
				day = day.length < 2 ? day = "0" + day : day;
				d.push(day);
			}
			return d;
		},
		getMonths(): any {
			const m: Array<string> = [];
			for (let i = 0; i != 12; ++i){
				let month = (i+1).toString();
				month = month.length < 2 ? month = "0" + month : month;
				m.push(month);
			}
			return m;
		},
		getYears(): any {
			const now = (new Date()).getFullYear();
			const y: Array<string> = [];
			for (let i = now - 18; i != now - 100; --i){
				y.push(i.toString());
			}
			return y;
		},
		isOver18(v: string): any {
			return Validation.isOver18(v);
		},
		handleFieldBlur(o: any, title: string): void {
			if (this.birthdayErrorMessages){
				this.$emit('blur', this.birthdayErrorMessages ? this.birthdayErrorMessages : true);
			}
			else {
				const e = !o.value ? title + ' required' : '';
				this.$emit('blur', e ? e : true);
			}
		},
		handleDayFocus(){
			this.$emit('focus', 'day');
			this.form.birthday.day.isFocussed = true; 
			!this.isTouchEnabled && (this.$refs.day as any).activateMenu();
		},
		handleMonthFocus(){
			this.$emit('focus', 'month');
			this.form.birthday.month.isFocussed = true; 
			!this.isTouchEnabled && (this.$refs.month as any).activateMenu();
		},
		handleYearFocus(){
			this.$emit('focus', 'year');
			this.form.birthday.year.isFocussed = true; 
			!this.isTouchEnabled && (this.$refs.year as any).activateMenu();
		},
		handleDayTab(e: any): void {
			if (!e.shiftKey && !!this.form.birthday.day.value && !this.form.birthday.month.value){
				(this.$refs.month as any).focus();
			}
		},
		handleMonthTab(e: any): void {
			if (!e.shiftKey && !!this.form.birthday.month.value && !this.form.birthday.year.value){
				(this.$refs.year as any).focus()
			}
		},
		handleYearTab(e: any): void {
			if (!e.shiftKey && !!this.form.birthday.year.value){
				this.$emit('blur');
			}
		},
		handleDayChange(){
			this.form.birthday.day.isDirty = true
			this.form.birthday.day.isFocussed = false;
			this.form.birthday.day.isDirty = true;
			this.handleFieldChange();
		},
		handleMonthChange(){
			this.form.birthday.month.isDirty = true
			this.form.birthday.month.isFocussed = false;
			this.form.birthday.month.isDirty = true;
			this.handleFieldChange();
		},
		handleYearChange(){
			this.form.birthday.year.isDirty = true
			this.form.birthday.year.isFocussed = false;
			this.form.birthday.year.isDirty = true;
			this.handleFieldChange();
		},
		handleFieldChange(): void {
			this.form.birthday.value = typeof Validation.isDate(this.dateString) !== 'string' ? this.dateString : '';
			this.handleBirthdayChange();
		},
		handleBirthdayChange(): void {
			this.form.birthday.isValid = !!this.form.birthday.value;
			this.$emit('input', this.form.birthday.value);
		} 
	}, 
	mounted(): void {
		this.days = this.getDays();
		this.years = this.getYears();
		this.months = this.getMonths();

		if (this.value){
			const v = this.value.split('-');
			if (v.length == 3){
				this.form.birthday.value = this.value;
				this.form.birthday.isValid = true;

				this.form.birthday.year.value = v[0];
				this.form.birthday.month.value = v[1];
				this.form.birthday.day.value = v[2];

				this.form.birthday.year.isDirty = true;
				this.form.birthday.month.isDirty = true;
				this.form.birthday.day.isDirty = true;
			}
		}
	}, 
	created(): void {
        try {  
          document.createEvent("TouchEvent");  
          this.isTouchEnabled = true;
        } 
        catch(e){  
          this.isTouchEnabled = false;
        }
	}
});
